function LenteNewsletterSubscribeForm({ url }) {

  // User button link as embed url
  let urlResult = url?.includes("/subscribe") ? url.replace("/subscribe", "/embed") : url

  return (
    <div className="newsletter-container"> {/* Usar className no lugar de class */}
      <iframe
        title="newsletter"
        src={urlResult ? urlResult : "https://agencialupa.substack.com/embed"}
        width="100%"
        height="550"
        style={{ border: '0px', background: 'white' }} // style deve ser um objeto
        frameBorder="0" // CamelCase em atributos não padrão HTML
        scrolling="no">
      </iframe>
    </div>
  );
}

export default LenteNewsletterSubscribeForm;
